import Cookies from 'js-cookie';
import { AuthHeaders } from './cookieTypes';

export function getCookie(name: string): string | undefined {
  return Cookies.get(name);
}

export function setCookie(key: string, value: string, expireDays = 14) {
  Cookies.set(`${key}`, value, { expires: expireDays, path: '/' });
}

export function getAuthHeadersFromCookie(): AuthHeaders | null {
  // TODO Handling missing role and regions here for backwards compatibility
  const authHeaders = Cookies.get('authHeaders');
  if (authHeaders) {
    return JSON.parse(authHeaders);
  } else {
    return null;
  }
}
